import { render, staticRenderFns } from "./GrandIcon.vue?vue&type=template&id=79ae1056&scoped=true"
import script from "./GrandIcon.vue?vue&type=script&lang=js"
export * from "./GrandIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae1056",
  null
  
)

export default component.exports